import React, { useEffect, useState, useCallback, useMemo, useRef } from 'react';
import './Footer.css';
import { Row, Col } from "react-flexbox-grid";
import * as apiClient from "../../services/apiClient";

const Footer = () => {
    const [translations, setTranslations] = useState([]);

    useEffect(() => {
        const FetchTranslations = async () => {
            const language = navigator.language.startsWith('es') ? 'es' : 'en';
            const labels = await apiClient.GetLabelsByController(language, "Footer");
            const data = await apiClient.GetTranslationsByLabels(language, labels);
            setTranslations(data);
        };

        FetchTranslations();
    }, []);

    /************************************************************************** Resto de funciones */
    const getTranslation = (label) => {
        const translation = translations.find((t) => t.label === label);
        return translation ? translation.body : '';
    };
    /************************************************************************** Fin resto de funciones */

    return (
        <div className="page-footer">
            <Row>
                <Col xs={12} md={6}>
                    <p className="footer-text1">{getTranslation('footer.Rights')}</p>
                </Col>
                <Col xs={12} md={6}>
                    <p className="footer-text2">{getTranslation('footer.Privacy')}</p>
                </Col>
            </Row>
        </div>
    );
}

export default Footer;